import React from 'react';

import CodeVerification from './CodeVerification';
import { useFormContext } from './FormContext';

const MobileNumberVerification = () => {
  const { inputs, otpReferenceId } = useFormContext();

  async function handleCodeVerification(verificationCode) {
    // OTP is bypassed for now — the code "0000" always succeeds. The real
    // verify + email-OTP-send calls are intentionally left out until OTP is on.
    if (verificationCode !== '0000') {
      return { shouldDisplayError: true, message: 'Entered OTP is incorrect' };
    }
    otpReferenceId.email = 'dev-bypass';
    return null;
  }

  return (
    <CodeVerification
      title='Verify Phone'
      handleCodeVerification={handleCodeVerification}
      description={`Code is sent to +94 *** ***${inputs.mobileNumber.slice(
        -3
      )}`}
    />
  );
};

export default MobileNumberVerification;
